import ENV from "./environment";

export const readyremit = {
  iframe: `
    <iframe 
      id="readyremit-iframe" 
      src="${ENV.RR_IFRAME_SRC}"
      allow="clipboard-read; clipboard-write; camera"    
      width="100%" 
      height="100%" 
      style="display: none;"
      title="International & Domestic Transfers"
		></iframe>
  `
}